import { withProps } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import withShop from './utils/withShop';
import { USER_TYPES } from './constants';
import { SHOP_TYPE } from '../main/shops/constants';

// if allow prop exists than deny prop does not matter
const ShopAware = ({ role, shopKind, allow, children, deny }) => {
  const display = (() => {
    if (role !== USER_TYPES.shop) return false;
    if (typeof allow === 'number') return shopKind === allow;
    if (typeof deny === 'number') return shopKind !== allow;
    return false;
  })();

  return (
    <div display-if={display}>
      { children }
    </div>
  );
};
ShopAware.propTypes = {
  children: PropTypes.node,
  role: PropTypes.number.isRequired,
  shopKind: PropTypes.number.isRequired,
  allow: PropTypes.number,
  deny: PropTypes.number,
};
ShopAware.defaultProps = {
  children: null,
  allow: null,
  deny: null,
};

const ShopAwareContainer = withShop(ShopAware);
export default ShopAwareContainer;

export const ShopAwareCommission = withProps({
  allow: SHOP_TYPE.commission,
})(ShopAwareContainer);
